import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  maxWidth: "100%",
  padding: "$md"
});